export default __webpack_public_path__ + "static/media/Explanation3.36d50188.JPEG";